// "Open full form": the app's own invite forms, opened with what a card holds
// so the user can finish there. Paths are the pay app's; the handoff keeps
// numbers and emails out of the URL.
import { useContext } from 'react';

import { useHistory } from 'react-router-dom';

import { WorkerInvitePrefill } from '../../../invites/prefill';
import { AdminInvitePrefill } from '../../../staff-management/prefill';
import { InviteDraftData, InviteTarget, NewPerson, isOnVyce } from './inviteDraft';
import { LailaCardsContext } from './LailaCardsContext';
import { StaffInviteData, roleOf } from './staffInvite';

export const WORKER_INVITE_FORM = '/user-management/company-invites?invite=1';
export const INVITES_PAGE = '/user-management/company-invites';
export const ADMIN_INVITE_FORM = '/user-management/admins?invite=1';

const chosen = (target: InviteTarget | null) => (target && !target.unavailable ? target.chosen : undefined);

export const workerInvitePrefillFrom = (data: InviteDraftData): WorkerInvitePrefill => {
  const team = chosen(data.team);
  const location = chosen(data.location);
  const shift = location && data.location?.shift?.chosen;
  const paySchedule = chosen(data.paySchedule);
  return {
    // People already on Vyce are picked again in the form: it needs their full records.
    phones: data.people
      .filter((person): person is NewPerson => !isOnVyce(person) && person.valid)
      .map(person => person.phone),
    targets: {
      teamIds: team ? [team.id] : [],
      locationIds: location ? [location.id] : [],
      shiftIdsByLocation: location ? { [location.id]: shift ? [shift.id] : [] } : {},
      payScheduleIds: paySchedule ? [paySchedule.id] : [],
      payScheme: (paySchedule && data.paySchedule?.scheme) || null,
    },
  };
};

export const adminInvitePrefillFrom = (data: StaffInviteData): AdminInvitePrefill => ({
  email: data.email.trim().toLowerCase(),
  position: data.position.trim(),
  roles: data.modules
    .filter(module => roleOf(module))
    .map(module => ({
      roleId: module.roleId as string,
      resourceIds: roleOf(module)!.scoped ? module.scope : [],
    })),
});

// Goes to a page of the app, out of the chat (the corner panel closes). No
// way to go, as outside a router, means no link.
export const useOpenPage = (): ((path: string) => void) | undefined => {
  const { openPage } = useContext(LailaCardsContext);
  const history = useHistory();
  return openPage ?? (history ? (path: string) => history.push(path) : undefined);
};
